document.querySelectorAll('.Index_feature_collections_title_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: true,
        spaceBetween: 32,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        breakpoints: {
            0: {
                freeMode: !1,
                spaceBetween: 20
            },
            750: {
                spaceBetween: 20
            },
            990: {
                spaceBetween: 32
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});

document.querySelectorAll('.Index_feature_collections_items_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: true,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: true,
        breakpoints: {
            0: {
                freeMode: false
            },
            750: {
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});